import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {AuthenticationService} from "@biletix/core/services/authentication.service";
import {LoggedInCustomer} from "@biletix/core/models/authentication/logged-in-customer.model";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {MenuItem} from "@biletix/core/view-models/menu-item.model";
import {RouterService} from "@biletix/core/services/router.service";
import {Router} from "@angular/router";
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {LocalStorageService} from "@biletix/core/services/local-storage.service";
import {WINDOW} from "@biletix/core/common";

const NOTIFICATION_UNREAD_COUNT_STORAGE_KEY = 'btxNotificationUnreadCount';
const NOTIFICATION_UNREAD_COUNT_EVENT = 'btx:notification-unread-count';

@Component({
    standalone: false,
    selector: 'btx-wide-account-dropdown',
    templateUrl: './account-dropdown.component.html',
    styleUrls: ['./account-dropdown.component.scss']
})
export class WideAccountDropdownComponent extends AbstractionComponent implements OnInit {

    loggedInCustomer?: LoggedInCustomer;
    unreadNotificationCount = 0;
    private readonly onUnreadNotificationCount = (event: Event): void => {
        this.unreadNotificationCount = this.normalizeUnreadCount((event as CustomEvent).detail);
    };
    menuItems: MenuItem[] = [];
    shoppingCartState: any;

    constructor(private authenticationService: AuthenticationService,
                private ticketSaleService: TicketSaleService,
                private router: Router,
                private localStorageService: LocalStorageService,
                private routerService: RouterService,
                @Inject(WINDOW) private window: Window,
                @Inject(PLATFORM_ID) private platformId: object) {
        super();
    }

    /**
     * Bildirim (zil) ikonu tıklaması. Zil yalnızca mobil uygulama modunda görünür
     * (.mobile-app-mode). App içindeyken native bildirim geçmişi ekranını köprüyle açar;
     * web/masaüstünde ReactNativeWebView olmadığından no-op'tur.
     * (Eskiden mobil taraftaki notificationBellScript.setupNotificationBell yapıyordu.)
     */
    onNotificationBellClick(event: Event): void {
        event.stopPropagation();
        const reactNativeWebView = (this.window as any)?.ReactNativeWebView;
        if (reactNativeWebView && typeof reactNativeWebView.postMessage === 'function') {
            reactNativeWebView.postMessage(JSON.stringify({action: 'openNotificationHistory'}));
        }
    }

    get unreadNotificationBadge(): string {
        return this.unreadNotificationCount > 99 ? '99+' : String(this.unreadNotificationCount);
    }

    private normalizeUnreadCount(value: unknown): number {
        const count = Number(value);
        return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
    }

    /**
     * Sayı uygulamadan gelir: sayfa açılırken localStorage'dan okunur, açıkken olayla güncellenir.
     * Web/masaüstünde ikisi de hiç yazılmaz → 0, rozet çıkmaz.
     */
    private watchUnreadNotificationCount(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        try {
            this.unreadNotificationCount = this.normalizeUnreadCount(
                this.window.localStorage?.getItem(NOTIFICATION_UNREAD_COUNT_STORAGE_KEY),
            );
        } catch {
            this.unreadNotificationCount = 0;
        }
        this.window.addEventListener(NOTIFICATION_UNREAD_COUNT_EVENT, this.onUnreadNotificationCount);
    }

    override ngOnDestroy(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.window.removeEventListener(NOTIFICATION_UNREAD_COUNT_EVENT, this.onUnreadNotificationCount);
        }
        super.ngOnDestroy();
    }

    onFootballIconClick(): void {
        this.window.location.href = 'https://www.biletix.com/fan-guide/TURKIYE/tr';
    }

    ngOnInit(): void {

        // get initial login state after DI
        this.loggedInCustomer = this.authenticationService.getLoggedInCustomer();

        //check login
        this.checkLogin();

        //watch login customer
        this.watchLoginUser();

        //
        this.buildAccountDropdownMenu();

        this.watchUnreadNotificationCount();
    }

    showTimerInHeader(){
        //const isMobile = this.getIsMobile();
        const isExistShoppingCart =this.isExistShoppingCart();
        const isCartPage =this.isCartPage();
        const isOrderSummaryExists =this.isOrderSummaryExists();

        //return !isMobile && isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;
        return isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;

      }

      isOrderSummaryExists(){
        return this.shoppingCartState && this.shoppingCartState.isNotEmpty();
      }

      isCartPage() {
        return this.router.url.indexOf('/cart') > -1;
      }


      isExistShoppingCart(): boolean {
          return this.ticketSaleService.isExistShoppingCart();
      }

    watchLoginUser() {
        this.authenticationService
            .watchLoggedInCustomer
            .pipe(this.takeUntilDestroy())
            .subscribe(loggedInCustomer => this.loggedInCustomer = loggedInCustomer);
    }

    checkLogin() {
        if (this.loggedInCustomer && this.loggedInCustomer.customerId) {
            this.authenticationService
                .checkLogin()
                .pipe(this.takeUntilDestroy())
                .subscribe(isLogin => {
                        if (!isLogin) {
                            this.localStorageService.clear();
                            this.ticketSaleService.clearLocalShoppingCart();
                            this.buildAccountDropdownMenu();
                        }
                    }
                );
        }
    }

    /**
     *
     */
    private buildAccountDropdownMenu() {
        this.menuItems = [
            //Profile menu item
            {
                order: 3, url: this.routerService.accountMyPersonalInformationUrl,
                label: "account.labels.myProfile", icon: 'person_outline'
            },
            //Addresses menu
            {
                order: 4, url: this.routerService.accountMyAddressesUrl,
                label: "shared.labels.myAddresses",
                icon: 'home'
            },
            //My Tickets
            {
                order: 5, url: this.routerService.accountMyTicketsUrl,
                label: "shared.labels.myTickets", icon: 'confirmation_number'
            },
          {
            order: 7, url: this.routerService.fanInfoUrl,
            label: "account.labels.fanInfo", icon: 'confirmation_number'
          },
            // {
            //     order: 6, url: this.routerService.accountFavoritesUrl,
            //     label: "shared.labels.myFavorites", icon: 'favorite_border'
            // }
        ];


        if (!this.isAuthenticated) {
            this.menuItems.push({
                order: 1,
                url: this.routerService.loginUrl,
                label: "auth.labels.signIn",
                icon: "login"
            });
            this.menuItems.push({
                order: 2,
                url: this.routerService.registerUrl,
                label: "auth.labels.createAccount",
                icon: "person_add_alt_1"
            });
        }

        return this.menuItems.sort((item1, item2) => item1.order < item2.order ? -1 : 1)
    }

    public get isAuthenticated(): boolean {
        return this.authenticationService.getLoggedInCustomer() ?? false;
    }

    public doLogout(): void {
        this.authenticationService
            .doLogout()
            .pipe(this.takeUntilDestroy())
            .subscribe(() => {
                    this.buildAccountDropdownMenu();
                    this.authenticationService.clearLogin();
                    this.ticketSaleService.clearLocalShoppingCart();

                    //TODO: Seam devre dışı kalınca aktif edilecek.
                    // this.routerService.navigateToHomePage()
                    this.routerService.navigateToSeamHomePage();
                }
            );
    }

    public get loggedInUserName() {
        let userName = this.loggedInCustomer?.name;
        if (userName && userName.length > 10) {
            return userName.substring(0, 10).concat("...");
        }
        return userName;
    }

}
